export default {
  REGION: `${process.env.REACT_APP_AWS_REGION}`,
  USER_POOL_ID: `${process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID}`,
  APP_CLIENT_ID: `${process.env.REACT_APP_AWS_COGNITO_USER_POOL_CLIENT_ID}`,
  IDENTITY_POOL_ID: `${process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID}`,
  GRAPHQL_URL: `${process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT}`,
}
